import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { PricingTableData } from "./table-data";

const Table = () => {
  return (
    <Container>
      <Body>
        <thead>
          <tr>
            <th scope="col">
              <Typography size="s" weight="semibold">
                Features
              </Typography>
            </th>
            <th scope="col">
              <Typography size="s" weight="medium">
                Independent
              </Typography>
            </th>
            <th scope="col">
              <Typography size="s" weight="semibold">
                Pro
              </Typography>
            </th>
            <th scope="col">
              <Typography size="s" weight="semibold">
                Label
              </Typography>
            </th>
          </tr>
        </thead>
        <tbody>
          {PricingTableData.map(
            ({ feature, icon, independent, label, pro }, i) => {
              const Check = () => {
                return (
                  <CheckIcon>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M7.99992 14.6666C11.6818 14.6666 14.6666 11.6819 14.6666 7.99998C14.6666 4.31808 11.6818 1.33331 7.99992 1.33331C4.31802 1.33331 1.33325 4.31808 1.33325 7.99998C1.33325 11.6819 4.31802 14.6666 7.99992 14.6666Z"
                        stroke="#FEA101"
                      />
                      <path
                        d="M5.66675 8.33331L7.00008 9.66665L10.3334 6.33331"
                        stroke="#FEA101"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </CheckIcon>
                );
              };
              return (
                <tr key={i}>
                  <td>
                    <FeatureContainer>
                      <FeatureIcon>{icon}</FeatureIcon>
                      <Typography size="s" weight="semibold">
                        {feature}
                      </Typography>
                    </FeatureContainer>
                  </td>
                  <td width={"25%"}>
                    {independent !== "check" ? (
                      <Typography size="s" weight="semibold">
                        {independent}
                      </Typography>
                    ) : (
                      <Check />
                    )}
                  </td>
                  <td width={"25%"}>
                    {pro !== "check" ? (
                      <Typography size="s" weight="semibold">
                        {pro}
                      </Typography>
                    ) : (
                      <Check />
                    )}
                  </td>
                  <td width={"25%"}>
                    {label !== "check" ? (
                      <Typography size="s" weight="semibold">
                        {label}
                      </Typography>
                    ) : (
                      <Check />
                    )}
                  </td>
                </tr>
              );
            }
          )}
        </tbody>
      </Body>
    </Container>
  );
};

export default Table;

const Container = styled.div`
  width: 100%;
  margin-top: 6.4rem;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const Body = styled.table`
  margin-bottom: 6.4rem;
  width: 100%;
  color: white;
  border-collapse: collapse;
  @media only screen and (max-width: 769px) {
    width: 100rem;
  }

  tr {
    background-color: transparent;

    border-radius: 0.4rem;
    &:nth-child(odd) {
      background-color: ${Colors.grey700};
    }
  }

  thead {
    tr {
      background-color: transparent !important;
    }
  }

  th {
    text-align: left;
    color: ${Colors.grey100};
    padding: 1.2rem 1.6rem;
    background-color: transparent !important;
    cursor: auto;
  }

  td {
    color: ${Colors.grey300};
    padding: 1.6rem;
  }
`;

const FeatureContainer = styled.div`
  display: flex;
  align-items: center;
`;

const FeatureIcon = styled.div`
  margin-right: 1rem;
  margin-left: 0.4rem;
  width: 1.6rem;
  height: 1.6rem;
`;

const CheckIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  margin-left: 1.6rem;
`;
